import {showAlternativeTextMenu, types} from '../actions/MenuActions';
import menuType from '../constants/MenuType';
import mode from '../constants/ModeConstants';
import zoomUtils from '../components/utils/ZoomUtils';
import createShapes from '../components/utils/CreateShapes';
import appParameters from '../components/utils/AppParameters';
import storeManager from '../store/StoreManager';
import mouseUtils from '../components/utils/MouseUtils';
import moodsUtils from '../components/utils/MoodsUtils';
import textEditorUtils from '../components/menus/textEditorTool/utils/TextEditorUtils';
import mindMapUtils from "../components/utils/MindMapUtils";

function hideMenus (state, types) {
    if (state.contextMode == mode.LINE_CONTEXT || state.contextMode == mode.FREEHAND_CONTEXT)
        return state;

    var mainMenus = [mode.SEARCH_CONTEXT, mode.TEXT, mode.FREEHAND, mode.SHAPES, mode.FRAMES, mode.EFFECTS, mode.MEDIA];
    var i;
    var shapeMenu;
    var slideMenu;
    var contextMenu;
    var effectsList;
    var universesMenu;
    var isContextMenuVisible = false;
    var hideContextMenu = false;
    var registerUndoRedoAction = false;
    var updateUniversesMenu = true;
    var clipartCategory = storeManager.getState().menu.clipartCategory;

    if (!clipartCategory || clipartCategory == 0 || clipartCategory == 1) {
        if (!clipartCategory || clipartCategory == 0) {
            if (appParameters.currentMainUniverse == '' || appParameters.currentTheme == '')
                updateUniversesMenu = false;
        } else if (clipartCategory == 1) {
            if (appParameters.currentVideoTheme == '')
                updateUniversesMenu = false;
        }
    }

    if (state.contextMode != undefined && state.contextMode != mode.CONTEXT_NONE)
        isContextMenuVisible = true;

    if (types == menuType.ALL_MENUS)
        types = [menuType.ALL_MENUS];

    mindMapUtils.reset();

    for (i=0; i<types.length; i++) {
        if (types[i] == menuType.ALL_MENUS) {
            shapeMenu = {isShapeMenuVisible:false};
            contextMenu = {contextMode:mode.CONTEXT_NONE};
            slideMenu = {slideMenuLeftPosition:-1};
            hideContextMenu = true;
            effectsList = {effectsListIsExpanded: false, fontsListIsExpanded: false, fontSizeListIsExpanded: false, fontLineHeightIsExpanded: false, mainAudioCategoryIsExpanded: false, secondAudioCategoryIsExpanded: false, soundEffectsCategoryIsExpanded: false, iosButtonsExpanded: false};

            if (updateUniversesMenu)
                universesMenu = {isUniversesVisible:false, isMainUniverse: false};

            if (mainMenus.indexOf(state.contextMode) != -1 && !mouseUtils.isCanvasAction)
                contextMenu = undefined;

            if (textEditorUtils.selectedTextShape != '')
                contextMenu = undefined;

            break;
        }

        if (types[i] == menuType.SHAPE_MENU) {
            shapeMenu = {isShapeMenuVisible:false};
        }

        if (types[i] == menuType.SLIDE_MENU) {
            slideMenu = {slideMenuLeftPosition:-1};
        }

        if (types[i] == menuType.UNIVERSES_MENU) {
            if (updateUniversesMenu)
                universesMenu = {isUniversesVisible:false, isMainUniverse: false};
        }

        if (types[i] == menuType.CONTEXT_MENU) {
            contextMenu = {contextMode:mode.CONTEXT_NONE};
            effectsList = {effectsListIsExpanded: false, fontsListIsExpanded: false, fontSizeListIsExpanded: false, fontLineHeightIsExpanded: false, mainAudioCategoryIsExpanded: false, secondAudioCategoryIsExpanded: false, soundEffectsCategoryIsExpanded: false};
            hideContextMenu = true;

            if (mainMenus.indexOf(state.contextMode) != -1 && !mouseUtils.isCanvasAction)
                contextMenu = undefined;

            if (textEditorUtils.selectedTextShape != '')
                contextMenu = undefined;
        }
    }

    if (isContextMenuVisible && hideContextMenu)
        registerUndoRedoAction = true;

    mouseUtils.isCanvasAction = false;
    moodsUtils.previewContextMenu = mode.CONTEXT_NONE;

    return Object.assign({}, state, shapeMenu, slideMenu, contextMenu, effectsList, universesMenu, {registerUndoRedoAction: registerUndoRedoAction});
}

function showMenu (state, type) {
    var menu;

    if (type == menuType.SHAPE_MENU)
        menu = {isShapeMenuVisible:true};

    if (type == menuType.UNIVERSES_MENU)
        menu = {isUniversesVisible:true};

    return Object.assign({}, state, menu);
}

function showMainUniverse (state, value) {
    return Object.assign({}, state, {isMainUniverse: value, isUniversesVisible:true});
}

function changeStyleTab (state, type) {
    return Object.assign({}, state, {tab: type});
}

function expandEffectsList (state, isExpanded) {
    return Object.assign({}, state, {effectsListIsExpanded: isExpanded});
}

function expandFontsList (state, isExpanded) {
    return Object.assign({}, state, {fontsListIsExpanded: isExpanded});
}

function expandFontSizeList (state, isExpanded) {
    return Object.assign({}, state, {fontSizeListIsExpanded: isExpanded});
}

function expandFontLineHeight (state, isExpanded) {
    return Object.assign({}, state, {fontLineHeightIsExpanded: isExpanded});
}

function selectMyMediaCategory (state, category) {
    return Object.assign({}, state, {myMediaCategory: category});
}

function expandAudioList (state, isExpanded, listType) {
    if (listType == 'all')
        return Object.assign({}, state, {mainAudioCategoryIsExpanded: false, secondAudioCategoryIsExpanded: false, soundEffectsCategoryIsExpanded: false});
    else {
        if (listType == 'soundEffects')
            return Object.assign({}, state, {
                soundEffectsCategoryIsExpanded: isExpanded
            });
        else
        if (listType == 'main')
            return Object.assign({}, state, {
                mainAudioCategoryIsExpanded: isExpanded,
                secondAudioCategoryIsExpanded: false
            });
        else
            return Object.assign({}, state, {
                mainAudioCategoryIsExpanded: false,
                secondAudioCategoryIsExpanded: isExpanded
            });
    }
}

function showZoomSlides(state, value) {
    if (value == false)
        zoomUtils.updateInitialPosition = true;

    return Object.assign({}, state, {showZoomSlides: value});
}

function showCroppingMenu(state, value) {
    return Object.assign({}, state, {showCroppingMenu: value});
}

function changeDrawingProperties(state, property, value) {
    if (property == 'strokeWidth')
        return Object.assign({}, state, {strokeWidth: value});
    else
        return Object.assign({}, state, {strokeColor: value});
}

export default function(state = {}, action) {

    switch (action.type) {

        case types.CHANGE_SLIDE_MENU_POSITION: {
            return Object.assign({}, state, {slideMenuLeftPosition: action.left});
        }

        case types.SET_BUTTONS_HOLDER_WIDTH: {
            return Object.assign({}, state, {buttonsHolderWidth: action.value});
        }

        case types.SET_CONTEXT_TARGET: {
            return Object.assign({}, state, {contextTarget: action.model, isShapeMenuVisible: action.visibleShapeMenu});
        }

        case types.CHANGE_CONTEXT_MODE: {
            if (action.mode != mode.SEARCH_CONTEXT)
                moodsUtils.previewContextMenu = action.mode;

            return Object.assign({}, state, {contextMode: action.mode, tab: mode.FILL_STYLE});
        }

        case types.HIDE_MENUS: {
            return hideMenus(state, action.menuTypes);
        }

        case types.SHOW_MENU: {
            return showMenu(state, action.menuType);
        }

        case types.SHOW_MAIN_UNIVERSE: {
            return showMainUniverse(state, action.value);
        }

        case types.CHANGE_STYLE_TAB: {
            return changeStyleTab(state, action.selectedTab);
        }

        case types.EXPAND_EFFECTS_LIST: {
            return expandEffectsList(state, action.isExpanded);
        }

        case types.EXPAND_FONTS_LIST: {
            return expandFontsList(state, action.isExpanded);
        }

        case types.EXPAND_FONT_SIZE_LIST: {
            return expandFontSizeList(state, action.isExpanded);
        }

        case types.EXPAND_FONT_LINE_HEIGHT: {
            return expandFontLineHeight(state, action.isExpanded);
        }

        case types.EXPAND_AUDIO_LIST: {
            return expandAudioList(state, action.isExpanded, action.listType);
        }

        case types.SELECT_MY_MEDIA_CATEGORY: {
            return selectMyMediaCategory(state, action.category);
        }

        case types.SHOW_DELETE_ALERT: {
            return Object.assign({}, state, {showDeleteAlert: action.value});
        }

        case types.SHOW_ALTERNATIVE_TEXT_MENU: {
            return Object.assign({}, state, {showAlternativeTextMenu: action.value});
        }
        case types.SHOW_DELETE_TRACK_ALERT: {
            return Object.assign({}, state, {showDeleteTrackAlert: action.value});
        }

        case types.SHOW_RECORDER: {
            return Object.assign({}, state, {showRecorder: action.value});
        }

        case types.SHOW_ADVANCED_MODE_ALERT: {
            return Object.assign({}, state, {showAdvancedModeAlert: action.value});
        }

        case types.SHOW_EXPORT_ALERT: {
            return Object.assign({}, state, {showExportAlert: action.value});
        }

        case types.SHOW_LOST_SESSION_ALERT: {
            return Object.assign({}, state, {showLostSessionAlert: action.value});
        }

        case types.SHOW_PRELOADER: {
            return Object.assign({}, state, {showPreloader: action.value});
        }

        case types.PRINT_MODE: {
            return Object.assign({}, state, {printMode: action.value});
        }

        case types.PRINT_TEMPLATE: {
            return Object.assign({}, state, {printTemplate: action.value});
        }

        case types.SHOW_SAVE_PRELOADER: {
            return Object.assign({}, state, {showSavePreloader: action.value});
        }

        case types.USE_IMAGE_AS_BACKGROUND: {
            createShapes.useImageAsBackground = action.value;
            return Object.assign({}, state, {useImageAsBackground: action.value});
        }

        case types.USE_BACKGROUND_AS_IMAGE: {
            createShapes.useBackgroundAsImage = action.value;
            return Object.assign({}, state, {useBackgroundAsImage: action.value});
        }

        case types.USE_FRAME_AS_IMAGE: {
            createShapes.useFrameAsImage = action.value;
            return Object.assign({}, state, {useFrameAsImage: action.value});
        }

        case types.USE_VIDEO_AS_BACKGROUND: {
            createShapes.useVideoAsBackground = action.value;
            return Object.assign({}, state, {useVideoAsBackground: action.value});
        }

        case types.SHOW_ZOOM_SLIDES: {
            return showZoomSlides(state, action.value);
        }

        case types.SHOW_CROPPING_MENU: {
            return showCroppingMenu(state, action.value);
        }

        case types.SET_RECORDING_STATUS: {
            return Object.assign({}, state, {recordingStatus: action.recordingStatus});
        }

        case types.SHOW_DESCRIPTION: {
            return Object.assign({}, state, {showDescription: action.value});
        }

        case types.EXIT_ALERT: {
            return Object.assign({}, state, {exitAlert: action.value});
        }

        case types.HAS_NOT_ACCESS: {
            return Object.assign({}, state, {hasNotAccess: action.value});
        }

        case types.CHANGE_CLIPART_CATEGORY: {
            return Object.assign({}, state, {clipartCategory: action.value});
        }

        case types.SHOW_VIDEO_EDITOR: {
            return Object.assign({}, state, {showVideoEditor: action.value});
        }

        case types.UPDATE_CONTROL_POINT: {
            return Object.assign({}, state, {updateValue: action.value});
        }

        case types.REFRESH_VIDEO_EDITOR: {
            return Object.assign({}, state, {refreshVideoEditor: action.value});
        }

        case types.GROUP_DRAWING_SHAPES: {
            return Object.assign({}, state, {groupDrawingShapes: action.value});
        }

        case types.CHANGE_DRAWING_PROPERTIES: {
            return changeDrawingProperties(state, action.property, action.value);
        }

        case types.SHOW_AUDIO_EDITOR: {
            return Object.assign({}, state, {showAudioEditor: action.value});
        }

        case types.CHANGE_AUDIO_TAB_INDEX: {
            return Object.assign({}, state, {audioTabIndex: action.index});
        }

        case types.CHANGE_CARTOONIST_TAB_INDEX: {
            return Object.assign({}, state, {cartoonistTabIndex: action.index});
        }

        case types.EXPAND_CLIPART_IOS_BUTTONS: {
            return Object.assign({}, state, {iosButtonsExpanded: action.value});
        }

        case types.SHOW_AUDIO_ALERT: {
            return Object.assign({}, state, {audioAlert: action.value, audioTitle: action.title});
        }

        case types.UPDATE_CURRENT_SLIDE_CONTENT: {
            return Object.assign({}, state, {updateSlide: action.value});
        }

        case types.SHOW_TEXT_EDITOR: { // used to only show the TEXT EDITOR for ios
            return Object.assign({}, state, {textShapeTarget: action.textShape});
        }

        case types.REFRESH_THEME_SELECTOR: {
            return Object.assign({}, state, {refreshValue: Math.random()});
        }

        case types.REFRESH_TEXT_EDITOR_TOOL: {
            return Object.assign({}, state, {refreshTextEditorTool: new Date().getTime()});
        }

        case types.REFRESH_SHAPE_POSITION: {
            let refreshValue = '';

            if (action.uuid && action.uuid.length > 0)
                refreshValue = refreshValue + action.uuid + '_' + new Date().getTime();
            else
                refreshValue = refreshValue + new Date().getTime();

            return Object.assign({}, state, {refreshShapePosition: refreshValue});
        }

        default:
            return state;
    }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/MenuReducer.js
 **/